import router from './router'
import { setLocale } from './lang';
import store from './store';
router.beforeEach((to, from, next) => {
  console.log("🚀 ~ from:", from)
  // if (to.path === from.path) {
  //   next(false)
  // } else {
  //   localStorage.setItem('event_id', JSON.stringify(to.query.event_id));
  //   next()
  // }

  localStorage.setItem('event_id', JSON.stringify(to.query.event_id));
  store.commit('SET_EVENT_ID', Number(to.query.event_id));
  const lang = to.query.lang;
  const supportedLocales = ['zh', 'en'];
  const locale = supportedLocales.includes(lang) ? lang : 'zh';
  sessionStorage.pcMicroSiteEditLang = locale;
  setLocale(locale);
  if (!to.query.lang) {
    const query = { ...to.query, lang: locale };
    next({
      path: to.path,
      query,
      params: to.params
    });
    return;
  }
  if (to.path.startsWith('/draft')) {
    sessionStorage.pcMicroStationMode = 'draft'
  } else {
    if (from.path.startsWith('/draft')) {
      const draftPath = '/draft' + to.path;
      sessionStorage.pcMicroStationMode = 'draft'
      const query = { ...to.query, lang: locale };
      next({ path: draftPath, query, params: to.params });
      return;
    } else {
      sessionStorage.pcMicroStationMode = 'formal'
    }
  }
  next();

})

